interface InfoIconProps extends React.SVGProps<SVGSVGElement> {
  textColor?: string;
  bgColor?: string;
}

export default function IconInfo({
  textColor = "#fff",
  bgColor = "#000",
  ...props
}: InfoIconProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      {...props}
    >
      <path
        fill={bgColor}
        d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z"
      />
      <path
        fill={textColor}
        d="M14.881 18.76v-.733c0-.586.136-1.254 1.017-1.986l.848-.7c.61-.489 1.102-1.075 1.102-2.003 0-1.058-.763-1.759-1.831-1.759-1.186 0-1.983.75-1.983 2.052 0 .26.017.472.102.847l-2.034-.196A4.166 4.166 0 0 1 12 13.37c0-1.986 1.424-3.37 4.017-3.37C18.49 10 20 11.172 20 13.224c0 1.156-.729 2.15-1.593 2.882l-.814.684c-.525.44-.712.814-.712 1.498v.472h-2ZM14.746 22v-2.084h2.305V22h-2.305Z"
      />
    </svg>
  );
}
